export default function ExploreTemplateIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.45459 1.45459H2.78792C2.05154 1.45459 1.45459 2.05154 1.45459 2.78792V5.45459C1.45459 6.19097 2.05154 6.78792 2.78792 6.78792H5.45459C6.19097 6.78792 6.78792 6.19097 6.78792 5.45459V2.78792C6.78792 2.05154 6.19097 1.45459 5.45459 1.45459Z"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1815 1.45459H10.5148C9.77841 1.45459 9.18146 2.05154 9.18146 2.78792V5.45459C9.18146 6.19097 9.77841 6.78792 10.5148 6.78792H13.1815C13.9178 6.78792 14.5148 6.19097 14.5148 5.45459V2.78792C14.5148 2.05154 13.9178 1.45459 13.1815 1.45459Z"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1815 9.1814H10.5148C9.77841 9.1814 9.18146 9.77835 9.18146 10.5147V13.1814C9.18146 13.9178 9.77841 14.5147 10.5148 14.5147H13.1815C13.9178 14.5147 14.5148 13.9178 14.5148 13.1814V10.5147C14.5148 9.77835 13.9178 9.1814 13.1815 9.1814Z"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.45459 9.1814H2.78792C2.05154 9.1814 1.45459 9.77835 1.45459 10.5147V13.1814C1.45459 13.9178 2.05154 14.5147 2.78792 14.5147H5.45459C6.19097 14.5147 6.78792 13.9178 6.78792 13.1814V10.5147C6.78792 9.77835 6.19097 9.1814 5.45459 9.1814Z"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
